module.exports = __webpack_public_path__ + "img/1080_02.538a06d4.jpg";